/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Phonesettings1Inputs */

const en_entity_phonesettings1 = /** @type {(inputs: Entity_Phonesettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone Settings`)
};

const de_entity_phonesettings1 = /** @type {(inputs: Entity_Phonesettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Phone Settings" |
*
* @param {Entity_Phonesettings1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_phonesettings1 = /** @type {((inputs?: Entity_Phonesettings1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Phonesettings1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_phonesettings1(inputs)
	return de_entity_phonesettings1(inputs)
});
export { entity_phonesettings1 as "entity_phoneSettings" }